const actions = [
    {
        routeName: 'notice_to_vacate.index',
        items: [
            {
                title: 'create a new ntv',
                routeName: 'notice_to_vacate.generalInformation',
            },
        ],
    },
];

export default actions;
